import classnames from "classnames";
import { enGB } from "date-fns/locale";
import React, { ReactElement } from "react";

import { formatDate } from "@utils/date";
import { shouldDisableAddToCart } from "@utils/disableAddToCart";

import { StoreDetailsModel } from "@redux/modules/api/data/stores/@types/storeDetails.model";

import OpeningHours from "./openingHours.component";
import Stock from "./stock.component";
import "./storeDetails.scss";

type Props = {
    onSelect: () => void;
    selectedStore?: string;
    store: StoreDetailsModel;
    isOnlyAvailableInStore: boolean;
    displayStockLevel: boolean;
};

const StoreDetails = ({
    store,
    onSelect,
    selectedStore,
    isOnlyAvailableInStore,
    displayStockLevel,
}: Props): ReactElement => {
    const isDisabled = !displayStockLevel
        ? false
        : shouldDisableAddToCart(store.productAvailability);

    let weekDay = formatDate(new Date(), "eeee", {
        locale: enGB,
    }).toUpperCase();

    const openingsHours = store.weekDayOpenings
        ? store.weekDayOpenings[weekDay]
        : undefined;

    return (
        <div
            data-store-code={store.code}
            className={"store-details d-flex py-2"}
        >
            {!isOnlyAvailableInStore && (
                <div
                    className={classnames(
                        "storeStockRadioButton",
                        isDisabled &&
                            !isOnlyAvailableInStore &&
                            "store-details--disabled",
                    )}
                >
                    <input
                        name="store"
                        type="radio"
                        checked={selectedStore === store.code}
                        disabled={isDisabled}
                        onClick={() => (isDisabled ? null : onSelect())}
                    />
                </div>
            )}
            <div className={"pl-3"}>
                <h5
                    className={classnames({
                        "store-details--clickable": !isDisabled,
                    })}
                    onClick={() => {
                        isDisabled ? null : onSelect();
                    }}
                >
                    {store.storeName}
                </h5>
                <div
                    className={classnames(
                        "storeStockInfo",
                        isDisabled &&
                            !isOnlyAvailableInStore &&
                            "store-details--disabled",
                        "small",
                        { "store-details--clickable": !isDisabled },
                    )}
                    onClick={() => {
                        isDisabled ? null : onSelect();
                    }}
                >
                    <p>{`${store.address?.streetName || ""} ${
                        store.address?.streetNumber || ""
                    } ${
                        store.address.streetName || store.address.streetNumber
                            ? ","
                            : ""
                    } ${store.address?.postalCode || ""} ${
                        store.address?.town || ""
                    }`}</p>
                    {openingsHours && <OpeningHours hours={openingsHours} />}
                    {displayStockLevel && (
                        <Stock
                            productAvailability={store.productAvailability!}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default StoreDetails;
